import Divider from '@dashboard/components/Divider';
import PropTypes from 'prop-types';
import React from 'react';

import useProduct from '../../useProduct';

import VariantsList from './components/VariantsList';
import ProductVariantsRequiredForm from './ProductVariantsRequiredForm';
import { VariantEditProvider } from './VariantEditContext';
import { VariantsProvider } from './VariantsContext';
import usePage from '@/dashboard/hooks/usePage';

const propTypes = {
  product: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
};

const defaultProps = {
  product: false,
};

const ProductVariantsForm = () => {
  const { refetch: refetchPage } = usePage();
  const { product } = useProduct();

  return (
    <VariantsProvider>
      <VariantEditProvider onChange={() => refetchPage()}>
        <VariantsList />
      </VariantEditProvider>

      {product.variants.length > 0 && (
        <>
          <Divider className="my-8" />

          <ProductVariantsRequiredForm />
        </>
      )}
    </VariantsProvider>
  );
};

ProductVariantsForm.propTypes = propTypes;
ProductVariantsForm.defaultProps = defaultProps;

export default ProductVariantsForm;
